import BulkUpdatePolygonManager from "../../../views/BulkUpdatePolygon";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkUpdatePolygonManagerRoutes = [
  {
    menuName: MenuNames.BULK_UPSERT_POLYGON,
    path: "/bulk-update-polygon",
    component: BulkUpdatePolygonManager,
    exact: true,
  },
];

export default BulkUpdatePolygonManagerRoutes;